/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionIn } from './TransactionIn';
import {
    TransactionInFromJSON,
    TransactionInFromJSONTyped,
    TransactionInToJSON,
} from './TransactionIn';

/**
 * 
 * @export
 * @interface MoneyInIDealConfirmOutput
 */
export interface MoneyInIDealConfirmOutput {
    /**
     * 
     * @type {TransactionIn}
     * @memberof MoneyInIDealConfirmOutput
     */
    transactions?: TransactionIn;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInIDealConfirmOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInIDealConfirmOutput interface.
 */
export function instanceOfMoneyInIDealConfirmOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInIDealConfirmOutputFromJSON(json: any): MoneyInIDealConfirmOutput {
    return MoneyInIDealConfirmOutputFromJSONTyped(json, false);
}

export function MoneyInIDealConfirmOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInIDealConfirmOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionInFromJSON(json['transactions']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInIDealConfirmOutputToJSON(value?: MoneyInIDealConfirmOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionInToJSON(value.transactions),
        'error': value.error,
    };
}

